/**
 * The size a picture renders at inside a ceiling: its own aspect, scaled down to fit, never up — what the
 * browser does for an `<img>` with `width/height: auto` under `max-width`/`max-height`, computed ahead so a
 * box can animate to it. Null when the picture reports no size (a failed or empty decode).
 */
export function fitPicture(natural: { w: number; h: number }, ceiling: { w: number; h: number }): { w: number; h: number } | null {
  if (!(natural.w > 0 && natural.h > 0)) return null;
  const scale = Math.min(1, ceiling.w / natural.w, ceiling.h / natural.h);
  return { w: Math.round(natural.w * scale), h: Math.round(natural.h * scale) };
}
